<template>
    <div class="o-dashboard">
        <div class="o-dashboard__breadcrumbs">

			<ul class="c-breadcrumbs">
				<li>
					<a href="/voormeldingen">Voormeldingen</a>
				</li>
				<li>
					<span>{{asn.w_number}}</span>
				</li>
			</ul>
		</div>
        <div>
            <h4>{{asn.w_number}}</h4>
        </div>

        <c-table
            ref="table"
            :columns="columns"
            :endpoint="'/api/getasnproducts/' + this.$route.params.id "
            :placeholder="'Zoeken op artikelomschrijving, artikelnummer en ordernummer'">
        </c-table>  

    </div>
</template>

<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import CTable from '@components/table/Table';

export default {
    mixins: [View, Form],
    components: {CTable},
    data() {
		return {
			asn: [],
		}
	},
    computed: {
        columns() {
            let columns = [
                {name: 'product.name', label: 'Artikelomschrijving', sortable: true, sort: true},
                {name: 'product.article_number', label: 'Artikelnummer', sortable: true},
                {name: 'asn.reference', label: 'Ordernummer', sortable: true},
                {name: 'expected', label: 'Aantal', sortable: true},
                {name: 'asn.expected', component: 'CColumnDatetime', label: 'Leverdatum', sortable: true},
                {name: 'asn.created_at', component: 'CColumnDateWithHours', label: 'Aanmelddatum', sortable: true},
                {name: "asn_id", label: "", component: 'CColumnButton', props: {route: 'preNotificationDetail'}},
            ];

            return columns;
        },
    },
    mounted(){
        this.$xhr.get('/api/asns/' + this.$route.params.id).then( ({result}) => {
            this.asn = result;
        }).catch((e) => {
            this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Voormeldinggegevens kunnen niet worden ingeladen'});
        });
    }

}
</script>
